import { memo } from "react";
import { BadgeCheck, Clock, XOctagon } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface SubscriptionBadgeProps {
  status: "trial" | "premium" | "expired";
  className?: string;
}

export const SubscriptionBadge = memo(({ status, className }: SubscriptionBadgeProps) => {
  const badges = {
    trial: {
      icon: Clock,
      text: "Free Trial",
      variant: "secondary" as const,
    },
    premium: {
      icon: BadgeCheck,
      text: "Premium",
      variant: "default" as const,
    },
    expired: {
      icon: XOctagon,
      text: "Trial Expired",
      variant: "destructive" as const,
    },
  };

  const { icon: Icon, text, variant } = badges[status];

  return (
    <Badge variant={variant} className={className}>
      <Icon className="w-4 h-4 mr-1" />
      {text}
    </Badge>
  );
});

SubscriptionBadge.displayName = 'SubscriptionBadge';